<template>
    <div class="flex items-center gap-2">
        Periode
        <USwitch
            v-model="switchValue"
            size="xl"
            autocomplete="on"
        />
        Åpne poster
    </div>
</template>

<script setup lang="ts">

import {computed} from 'vue'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: false
    }
})

const emit = defineEmits(['update:modelValue'])

const switchValue = computed({
    get: () => {
        return props.modelValue
    },
    set: (value: boolean) => {
        emit('update:modelValue', value || undefined)
    }
})

</script>

<style scoped>

</style>